import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { Layout } from 'src/styles';

import { useHasPermissionsMulti } from 'src/hooks/useHasPermissions';
import {
  CAN_REVIEW_FLOCOS,
  ENTREPOSTO_VIEWS,
  NON_ENTREPOSTO_VIEWS,
} from 'src/constants/Permission';

import AsmubipButton from './AsmubipButton';
import WhatsAppHelpButton from './WhatsAppHelpButton';

export default function BottomBar({ isMobile }: { isMobile?: boolean }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [hasSignupAccess, nonEntrepostoView, canReviewFlocos, isEntrepostoView] =
    useHasPermissionsMulti(['signup', NON_ENTREPOSTO_VIEWS, CAN_REVIEW_FLOCOS, ENTREPOSTO_VIEWS]);

  const handleMenuClick = (targetPage: string) => {
    setOpen(false);
    navigate(targetPage);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(!open);
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <AppBar
        position="fixed"
        color="default"
        elevation={0}
        sx={{ top: 'auto', bottom: 0, paddingLeft: isMobile ? 0 : 5 }}>
        <Toolbar sx={Layout.bottomBar}>
          <WhatsAppHelpButton />
          <AsmubipButton variant="contained" onClick={handleClick}>
            {open ? (
              <RemoveIcon sx={Layout.bottomBarButtons} />
            ) : (
              <AddIcon sx={Layout.bottomBarButtons} />
            )}
          </AsmubipButton>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClick}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        sx={Layout.bottomBarMenu}>
        {nonEntrepostoView && (
          <>
            <MenuItem
              onClick={() => {
                handleMenuClick('/azeite_production/create');
              }}>
              Produção de azeite
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleMenuClick('/oleo_production/create');
              }}>
              Produção de óleo
            </MenuItem>
          </>
        )}
        {isEntrepostoView && (
          <MenuItem
            onClick={() => {
              handleMenuClick('/mesocarpo_processing/create');
            }}>
            Beneficiamento de mesocarpo
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleMenuClick('/flocos_production/create');
          }}>
          Produção de flocos
        </MenuItem>
        {canReviewFlocos && (
          <MenuItem
            onClick={() => {
              handleMenuClick('/flocos_production/?status=ready_to_review');
            }}>
            Revisar lotes de floco
          </MenuItem>
        )}
        {hasSignupAccess && (
          <MenuItem
            onClick={() => {
              handleMenuClick('/signup/create');
            }}>
            Adicionar usuária
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
